import React, { useState } from 'react';
import './DealTable.css';
import DealModel from './DealModel';
import apiService from '../api/apiService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DealTable = ({ deals, setDealData, onEdit, onDelete }) => {
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // const handleEdit = (deal) => {
  //   setSelectedDeal(deal);
  //   setIsEditModalOpen(true);
  // };

  const handleEditClick = deal => {
    setSelectedDeal(deal); // Ensure it's a fresh object
    setIsEditModalOpen(true);
  };

  const handleEdit = updatedItem => {
    setDealData(prevData =>
      prevData.map(item => (item.id === updatedItem.id ? updatedItem : item))
    );
    setIsEditModalOpen(false);
    setSelectedDeal(null);
  };

  const handleDelete = async dealId => {
    console.log(dealId);
    try {
      await apiService.patch(`/deals/${dealId}/`, {
        is_archive: true,
      });
      onDelete(dealId);
      toast.error('Deal deleted successfully!', {
        position: 'top-center',
        autoClose: '1500',
      });
    } catch (error) {
      toast.error('Failed to delete! Please try again.', {
        position: 'top-center',
        autoClose: '1500',
      });
      console.log(error);
    }
  };

  return (
    <div className="deal-table-container">
      <table className="deal-table">
        <thead>
          <tr>
            <th>Reference number</th>
            <th>Deal name</th>
            <th>Reservations left</th>
            <th>End date</th>
            <th>Room type</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {deals.map((deal, index) => (
            <tr key={index}>
              <td>{`#${deal.reference_number}`}</td>
              <td>{deal.deal_name}</td>
              <td>{deal.reservations_left}</td>
              <td>{deal.end_date}</td>
              <td>{deal.room_type}</td>
              <td className={`status status-${deal.status.toLowerCase()}`}>
                {deal.status}
              </td>
              <td>
                <div className="options-menu">
                  <button className="options-button">⋮</button>
                  <div className="dropdown-menu">
                    <button
                      className="edit-btn"
                      onClick={() => handleEditClick(deal)}
                    >
                      Edit
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(deal.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Edit Modal */}
      {isEditModalOpen && (
        <DealModel
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          onSave={handleEdit}
          initialData={selectedDeal}
        />
      )}
      <ToastContainer />
    </div>
  );
};

export default DealTable;
